import React, { memo, useCallback, useState } from 'react'
import { Grid, styled } from '@mui/material'
import { LoadingImageProps } from './LoadingImage.types'
import { secure } from '../api'
import Retrievable from './Retrievable'

const Image = styled('img')(({ theme }) => ({
    maxWidth: '100%',
}))

const Background = styled(Grid)(({ theme }) => ({
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    padding: theme.spacing(4),
}))

function LoadingImage({
    variant = 'image',
    path,
    children,
    attrs,
}: LoadingImageProps) {
    const [url, setUrl] = useState<string>()

    const getData = useCallback(async () => {
        if (!path) {
            return undefined
        }

        if (path.startsWith('http')) {
            return path
        }

        const response = await secure({
            http_method: 'GET',
            key: path,
            temporal: true,
            seconds: 10,
        })
        return response.url
    }, [path])

    return (
        <Retrievable
            getPromise={getData}
            setData={setUrl}
            builder={() => {
                if (variant === 'image') {
                    return (
                        <Image
                            src={url ?? '/image-target-placeholder.jpg'}
                            alt={
                                url
                                    ? `${url.substring(url.lastIndexOf('/'))}`
                                    : 'placeholder'
                            }
                            crossOrigin="anonymous"
                            {...attrs}
                        />
                    )
                }
                return (
                    <Background
                        item
                        xs={12}
                        sx={{ backgroundImage: `url('${url}')` }}
                    >
                        {children}
                    </Background>
                )
            }}
        />
    )
}

export default memo(LoadingImage)
